import { Injectable } from '@angular/core';
import { ModalComponent } from '../_components/modals/modal.component';
import { ValidationModalComponent } from '../_components/modals/validation-modal/validation-modal.component';
import { ProvideInfoModalComponent } from '../_components/modals/provide-info-modal/provide-info-modal.component';
import { FilterModalComponent } from '../_components/modals/filter-modal/filter-modal.component';
import { ApprovalsRequestModalComponent } from '../_components/modals/approvals-request-modal/approvals-request-modal.component';
import { ErrorLogModalComponent } from '../_components/modals/error-log-modal/error-log-modal.component';
import { InfoBannerModalComponent } from '../_components/modals/info-banner-modal/info-banner-modal.component';
import { EditLicenceTypeModalComponent } from '../_components/modals/edit-licence-type-modal/edit-licence-type-modal.component';
import { RecoveryCodesModalComponent } from '../_components/modals/recovery-codes-modal/recovery-codes-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private modals: (
    | ModalComponent
    | ValidationModalComponent
    | ProvideInfoModalComponent
    | FilterModalComponent
    | ApprovalsRequestModalComponent
    | ErrorLogModalComponent
    | InfoBannerModalComponent
    | EditLicenceTypeModalComponent
    | RecoveryCodesModalComponent
  )[] = [];

  add(
    modal:
      | ModalComponent
      | ValidationModalComponent
      | ProvideInfoModalComponent
      | FilterModalComponent
      | ApprovalsRequestModalComponent
      | ErrorLogModalComponent
      | InfoBannerModalComponent
      | EditLicenceTypeModalComponent
      | RecoveryCodesModalComponent
  ): void {
    // Add modal to array of active modals
    this.modals.push(modal);
  }

  remove(id: string): void {
    this.modals = this.modals.filter(
      (x) => (typeof x.id === 'function' ? x.id() : x.id) !== id,
    );
  }

  open(id: string): void {
    const modal = this.modals.find(
      (x) => (typeof x.id === 'function' ? x.id() : x.id) === id,
    );
    if (modal) {
      modal.open();
    }
  }

  close(id: string): void {
    const modal = this.modals.find(
      (x) => (typeof x.id === 'function' ? x.id() : x.id) === id,
    );
    if (modal) {
      modal.close();
    }
  }
}
